export interface CommentsConfigState {
  entityTypes: string[];
  loading: boolean;
  error: string | null;
}

export const initialCommentsConfigState: CommentsConfigState = {
  entityTypes: [],
  loading: false,
  error: null
};
